import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pageTotal.module.scss"

import { secondsToHours } from "@src/utils/data-parser"
import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "react-spring"
import bgImg from "@images/2022/p4/16-100.jpg"
import iconFaceImg from "@images/2022/p4/17.png"
import iconDeviceImg from "@images/2022/p4/18.png"
import iconGadioImg from "@images/2022/p4/19.png"
import iconEarphoneImg from "@images/2022/p4/20.png"

const parseData = ({ total: { thisYear, spending } }) => {
  return {
    total: thisYear,
    listen: secondsToHours(spending * 60),
  }
}

const PageTotal = createPage(
  ({ data, offset }) => {
    const {
      total,
      listen: { hours, minutes, seconds },
    } = parseData(data)
    const target = callYou(data)
    const anime1Styles = useEnteringTrail(4, offset, { type: "mt" })
    const anime2Styles = useEnteringTrail(2, offset, { step: 0.4, type: "mb" })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.9 })
    return (
      <>
        <div>
          <div className="iconsGroup">
            <div>
              <animated.img
                src={iconEarphoneImg}
                className={styles.iconEarphone}
                style={anime1Styles[0]}
              />
              <animated.img
                src={iconGadioImg}
                className={styles.iconGadio}
                style={anime1Styles[1]}
              />
              <animated.img
                src={iconDeviceImg}
                className={styles.iconDevice}
                style={anime1Styles[2]}
              />
              <animated.img
                src={iconFaceImg}
                className={styles.iconFace}
                style={anime1Styles[3]}
              />
            </div>
          </div>
        </div>

        <div>
          <animated.p style={anime2Styles[0]}>
            2022年
            <br />
            <span className="gColor">{target}</span>一共听了
            <span className="gColor">{total}</span>期节目
          </animated.p>
          <animated.p style={anime2Styles[1]}>
            {hours && (
              <span>
                <span className="gColor">{hours}</span>
                小时
              </span>
            )}
            <span>
              <span className="gColor">{minutes || seconds}</span>
              {minutes ? "分钟" : "秒"}
            </span>
            <br />
            是机核陪{target}度过的
          </animated.p>
        </div>

        <animated.div className="bottomText" style={anime3Styles[0]}>
          2022 年机核全年共制作 651 期节目
          <br />
          节目总时长 642 小时 9 分钟
        </animated.div>
      </>
    )
  },
  {
    className: "pageLayout1",
  }
)

export const pageTotalData = {
  key: "total",
  bgImg,
  Page: PageTotal,
  shouldHide: (data) => data.attributes["radio-plays-count"] === 0,
}

export default PageTotal
